import { fr, enUS, es, de, it, pt } from "date-fns/locale"
import { normalizeLocale } from "./translationLoader"

export const DATE_LOCALE_CONFIG = {
  en: { localeKey: "en", dateFns: enUS, timeCaption: "Time" },
  fr: { localeKey: "fr", dateFns: fr, timeCaption: "Heure" },
  es: { localeKey: "es", dateFns: es, timeCaption: "Hora" },
  de: { localeKey: "de", dateFns: de, timeCaption: "Zeit" },
  it: { localeKey: "it", dateFns: it, timeCaption: "Ora" },
  pt: { localeKey: "pt", dateFns: pt, timeCaption: "Hora" },
} as const

type DateLocaleKey = keyof typeof DATE_LOCALE_CONFIG

export function getDateLocaleConfig(langageId?: string | number | null) {
  const normalized = normalizeLocale(langageId) || "en"
  const base = normalized.split(/[-_]/)[0]?.toLowerCase() || "en"
  const config =
    DATE_LOCALE_CONFIG[base as DateLocaleKey] || DATE_LOCALE_CONFIG.en
  return { ...config, base }
}



